import React, { useState, useEffect } from 'react';
import { Snackbar } from '@mui/material';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';

import useStores from './stores/useStores';

const NotificationBar = () => {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(null);
  const { userStore } = useStores();

  useEffect(
    () =>
      autorun(() => {
        const [notification] = userStore.notifications.slice(-1);
        if (notification) {
          setNotification(notification);
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
          }, 5000);
        }
      }),
    []
  );

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      message={notification?.title}
    />
  );
};

export default observer(NotificationBar);
